/*global jQuery, angular */

// Скролл для информера
(function($) {
    $(window).load(function() {
        $("#header-informer").mCustomScrollbar({
            scrollButtons: {
                enable: false
            }
        });
        $("#header-informer").hover(function() {
            $(document).data({"keyboard-input": "enabled"});
            $(this).addClass("keyboard-input");
        }, function() {
            $(document).data({"keyboard-input": "disabled"});
            $(this).removeClass("keyboard-input");
        });
        $(document).keydown(function(e) {
            if ($(this).data("keyboard-input") === "enabled") {
                var activeElem = $(".keyboard-input"),
                    activeElemPos = Math.abs($(".keyboard-input .mCSB_container").position().top),
                    pixelsToScroll = 60;
                if (e.which === 38) { //scroll up
                    e.preventDefault();
                    if (pixelsToScroll > activeElemPos) {
                        activeElem.mCustomScrollbar("scrollTo", "top");
                    } else {
                        activeElem.mCustomScrollbar("scrollTo", (activeElemPos - pixelsToScroll), {scrollInertia: 400, scrollEasing: "easeOutCirc"});
                    }
                } else if (e.which === 40) { //scroll down
                    e.preventDefault();
                    activeElem.mCustomScrollbar("scrollTo", (activeElemPos + pixelsToScroll), {scrollInertia: 400, scrollEasing: "easeOutCirc"});
                }
            }
        });
    });
})(jQuery);


var informant = angular.module('informant', ['infinite-scroll', 'ngCookies','ngSanitize']);

informant.controller('InformantController', ['$scope', '$http', '$cookies', function ($scope, $http, $cookies) {
    $scope.items = [];


    $scope.init = function() {
        $http.get('/informant/').success(function (data) {
            $scope.items = data;
        });

    };


    $scope.deleteItem = function(id) {
        var new_items = [];
        for (var i= 0; i < $scope.items.length; i++) {
            if (id != i) {
                new_items.push($scope.items[i]);
            }
        }

        $scope.items = new_items;
        return false;

    };

    $scope.deleteAll = function() {
        $scope.items = [];
        var token = $cookies.csrftoken;
        $http.post('/informant/delete/',{headers: {'X-CSRFToken': token}}).success(function (data) {

        });

        return false;
    };
}]);
